import PieceRamaceDesktop from "./PieceRamaceDesktop";

const PieceRamaceMobile = () => <PieceRamaceDesktop />;

export default PieceRamaceMobile;
